import React from 'react';
import * as Yup from 'yup';
import { Box, Typography } from '@mui/material';
import { Formik } from 'formik';
import { Alert, CancelButton, Modal, ModalActions, ModalContent, SubmitButton, TextInput, useAlert } from '@uplift/ui-v2';
import { UploadedProviderDocument } from '@uplift/api';
import { useDeleteUploadedProviderDocumentMutation } from '@uplift/queries';
import { useL10n } from '@uplift/hooks';


const validationSchema = Yup.object().shape({
  reasonForDelete: Yup.string().required('A deletion reason is required'),
});


export const DeleteUploadedProviderDocumentModal: React.VFC<{
  open: boolean;
  onClose: () => void;
  onSuccess: () => Promise<void>;
  document: UploadedProviderDocument;
}> = (props) => {
  const l10n = useL10n();
  const alert = useAlert();
  const deleteMutation = useDeleteUploadedProviderDocumentMutation(props.document.providerId);

  return (
    <Formik
      enableReinitialize
      initialValues={{
        reasonForDelete: '',
      }}
      validateOnMount
      validationSchema={validationSchema}
      onSubmit={async (values) => {
        try {
          await deleteMutation.mutateAsync({ documentId: props.document.id, reason_for_delete: values.reasonForDelete });
          await props.onSuccess();
          alert.success('Document deleted');
        } catch {
          alert.error(<>There was a problem deleting the document. Try again or contact <strong>{l10n.helpEmail}</strong></>);
        }
      }}
    >
      <Modal
        open={props.open}
        onClose={props.onClose}
        fullWidth
        maxWidth="md"
        slotProps={{ paper: { style: { maxWidth: '600px' } } }}
        title="Delete document"
      >
        <ModalContent>
          <Alert severity="warning">
            <Typography>
              Deleting will remove this document and this action cannot be undone.
            </Typography>
          </Alert>
          <Box mt={3} width="100%">
            <TextInput
              name="reasonForDelete"
              label="Why are you deleting this document?"
              color="secondary"
              multiline
              minRows={1}
              fullWidth
            />
          </Box>
        </ModalContent>
        <ModalActions>
          <CancelButton onClick={props.onClose}>Cancel</CancelButton>
          <SubmitButton color="error">Delete document</SubmitButton>
        </ModalActions>
      </Modal>
    </Formik>
  );
};
